<template>
  <div class="jackPotNew">
    <el-dialog width="1070px" :visible.sync="adVisible" :show-close="false">
      <div class="jkContent">
        <ul class="jkTabs">
          <li v-for="(item,index) in adList" :key="index" :class="{ 'active': index === currentIndex }" @click="changeTab(item,index)">
            <i></i>
            <span>{{ item.title }}</span>
          </li>
        </ul>
        <div class="jkHtml" v-html="currentList.contentPc"></div>
      </div>
      <div class="jkClose" @click="closePop"></div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      adVisible: false,
      isToday: "",
      adList: [],
      currentIndex: 0, //当前tab
      currentList: {} //当前列表
    };
  },
  mounted() {
    this.getGuideAd();
  },
  methods: {
    getGuideAd() {
      let self = this;
      self.$http.get(self.$api.getGuideAd).then((res) => {
        if (res && res.code == 0) {
          self.adList = res.data;
          self.currentList = res.data[0] || {};
          if (res.data.length) self.advertisingShow();
        }
      });
    },
    //弹出逻辑
    advertisingShow() {
      //弹出逻辑,popUpRule为0 1 2 分别对应弹出次数
      let self = this;
      let popUpRule = self.adList[0].popUpRule;
      if (popUpRule === 0) {
        //不弹
        return;
      } else if (popUpRule === 1) {
        //弹一次
        const JpOrAdv = sessionStorage.getItem("JpOrAdv");
        if (!JpOrAdv) {
          let t = localStorage.getItem("isToday");
          if (t) {
            //有时间
            let nowt = new Date().getTime();
            self.isToday = self.$common.isToday(t, nowt);
            if (!self.isToday) {
              self.adVisible = true;
              sessionStorage.setItem("JpOrAdv", true);
            }
          } else {
            //没时间
            self.adVisible = true;
            let timestamp = new Date().getTime();
            localStorage.setItem("isToday", timestamp);
            sessionStorage.setItem("JpOrAdv", true);
          }
        }
      } else if (popUpRule === 2) {
        //每次打开都弹
        const JpOrAdv = sessionStorage.getItem("JpOrAdv");
        if (!JpOrAdv) {
          self.adVisible = true;
          sessionStorage.setItem("JpOrAdv", true);
        }
      }
    },
    changeTab(item,index) {
      if (index === this.currentIndex) return;
      this.currentIndex = index;
      this.currentList = item;
    },
    closePop() {
      this.adVisible = false;
    }
  },
};
</script>
<style lang="less">
.jackPotNew {
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #f6daa7;
    border-radius: 5px;
  }
  div {
    box-sizing: border-box;
  }
  .el-dialog {
    background-color: transparent;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 0;
      .jkContent {
        display: flex;
        justify-content: space-between;
        width: 1070px;
        height: 497px;
        padding: 35px 22px 62px 35px;
        background: url('../../assets/image/pubilc/jk_bg.png');
        .jkTabs {
          width: 338px;
          overflow: auto;
          li {
            cursor: pointer;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            width: 328px;
            height: 55px;
            margin-bottom: 15px;
            padding: 0 25px;
            background: url('../../assets/image/pubilc/jk_tab.png') no-repeat; 
            i {
              display: inline-block;
              width: 50px;
              height: 28px;
              margin-right: 6px;
              background: url('../../assets/image/pubilc/jk_icon.png'); 
            }
            span {
              font-size: 22px;
              color: #bebebe;
              max-width: 221px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            &.active {
              background: url('../../assets/image/pubilc/jk_tab_active.png') no-repeat; 
              i {
                background: url('../../assets/image/pubilc/jk_icon_active.png'); 
              }
              span {
                color: #000;
              }
            }
            &:hover {
              opacity: .9;
            }
          }
        }
        .jkHtml {
          width: 658px;
          height: 396px;
          overflow: auto;
          border: solid 1px #4a4333;
          background-color: #fff;
          border-radius: 7px;
          padding: 10px;
          img {
            width: auto;
            height: auto;
          }
        }
      }
      .jkClose {
        cursor: pointer;
        width: 80px;
        height: 80px;
        margin: 15px auto 0;
        background: url('../../assets/image/pubilc/jk_close.png') no-repeat;
        &:hover {
          opacity: .9;
        }
      }
    }
  }
}
</style>